<template>
  <Bar id="my-chart-id" :options="props.options" :data="props.chartData" />
</template>

<script setup>
import { Bar } from "vue-chartjs";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
} from "chart.js";

import AnnotationPlugin from "chartjs-plugin-annotation";
import { getCurrentInstance, onMounted } from "vue";

// Mipws auto prepei na ginei mia fora stin arxi? Den katalavainw giati varaei pantws an den to valeis.
ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement
);

const props = defineProps({
  chartData: {
    type: Object,
    required: true,
  },
  options: {
    type: Object,
    required: true,
  },
  aspectRatio: {
    type: Object,
    required: false,
    default: null,
  },
});

const instance = getCurrentInstance();

// onMounted(() => {
//
//   // Chart.plugins.register(AnnotationPlugin)
//   // if (props.aspectRatio) {
//   //   instance.refs.canvas.width = props.aspectRatio.width
//   //   instance.refs.canvas.height = props.aspectRatio.height
//   // }
//   // this.addPlugin([AnnotationPlugin])
//   // this.renderChart(props.chartData, props.options)
// })
</script>

<style scoped></style>
